export class CachedFileCollectionItem {
    constructor(fileCollectionItem) {
        this.fileCollectionItem = fileCollectionItem;
    }
    async text() {
        if (this.arrayBufferCache) {
            return new TextDecoder().decode(this.arrayBufferCache);
        }
        return (this.textCache =
            this.textCache || (await this.fileCollectionItem.text()));
    }
    async arrayBuffer() {
        return (this.arrayBufferCache =
            this.arrayBufferCache || (await this.fileCollectionItem.arrayBuffer()));
    }
    stream() {
        return this.fileCollectionItem.stream(); // no cache for stream !
    }
    get lastModified() {
        return this.fileCollectionItem.lastModified;
    }
    get name() {
        return this.fileCollectionItem.name;
    }
    get relativePath() {
        return this.fileCollectionItem.relativePath;
    }
    get size() {
        return this.fileCollectionItem.size;
    }
}
//# sourceMappingURL=CachedFileCollectionItem.js.map